import styled from 'styled-components'
import { Box } from 'src/components'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
`
export const OverSection = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
        align-items: center;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
        flex-direction: row;
        justify-content: space-between;
        align-items: start;
    }
`
